import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    clearAddEditModalValue,
    setCurrentPage,
    setHasInputChange,
    setHasInputNoChange,
    setIsConfirmationModalOpen,
    setModalOpen,
    setReload
} from 'store/ResponseTemplate/actions';
import { useTheme } from '@mui/material/styles';
import {
    Button,
    IconButton,
    Box,
    FormControl,
    InputLabel,
    OutlinedInput,
    Grid,
    Stack,
    List,
    ListItem,
    ListItemIcon,
    Typography,
    Breadcrumbs,
    Link,
    Divider,
    Input,
    Popover,
    MenuItem,
    ListItemText
} from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useMutation } from '@apollo/client';
import { SET_LOADING, SET_TOAST_OBJECT } from 'store/actions';
import * as Yup from 'yup';
import { Form, Formik } from 'formik';
import FormFields from 'Components/FormFields';
import { CREATE_QUESTION_REGISTRY } from 'schemas/mutation';
import { useNavigate } from 'react-router-dom';
import CloseConfirmationModal from './CloseConfirmation';
import AllQuestionsIcon from 'Components/Icons/AllQuestionsIcon';
import QuestionRegistryIcon from 'Components/Icons/QuestionRegistryIcon';
import { MoreHoriz } from '@mui/icons-material';
import StarFilledIcon from 'Components/Icons/StarFilledIcon';
import StarIcon from 'Components/Icons/StarIcon';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import TrashIcon from 'Components/Icons/TrashIcon';
import DraftIcon from 'Components/Icons/DraftIcon';
import PerfectScrollbar from 'react-perfect-scrollbar';

const AddNewTemplate = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const navigate = useNavigate();
    const { companyData } = useSelector((params) => params.customization);
    const { templateType, hasInputValue, hasInputNoChange, isConfirmationModalOpen, reload, currentPage } = useSelector(
        (params) => params.response
    );
    const [addResponseTemplate, { data: addQuestionRegistry }] = useMutation(CREATE_QUESTION_REGISTRY);
    const [drafted, setIsDrafted] = useState(false);
    const [title, setTitle] = useState('Untitled question');
    // const [starred, setStarred] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [formState, setFormState] = useState({
        question: '',
        response: '',
        isDrafted: true
    });

    useEffect(() => {
        if (addQuestionRegistry) {
            dispatch({ type: SET_LOADING, loading: false });
            dispatch({ type: setModalOpen, modalOpen: false });
            dispatch({ type: clearAddEditModalValue });
            navigate('/dashboard/question-registry');
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    variant: 'success',
                    message: drafted ? 'Saved as draft sucessfully.' : 'Question has been added to your question registry.'
                }
            });

            setIsDrafted(false);
        }
    }, [addQuestionRegistry, dispatch]);

    const handleAddResponse = async (values, drafted) => {
        dispatch({ type: SET_LOADING, loading: true });
        setIsDrafted(drafted);
        try {
            await addResponseTemplate({
                variables: {
                    addQuestionRegistryInput: {
                        companyId: companyData._id,
                        question: values.question,
                        response: values.response,
                        drafted
                    }
                }
            });
            if (currentPage !== 1) {
                dispatch({ type: setCurrentPage, currentPage: 1 });
            } else {
                dispatch({ type: setReload, reload: !reload });
            }
        } catch (e) {
            dispatch({
                type: SET_TOAST_OBJECT,
                toastObject: {
                    status: true,
                    variant: 'error',
                    message: e.message || 'Something error occured in server'
                }
            });
            setIsDrafted(false);
        } finally {
            dispatch({ type: SET_LOADING, loading: false });
        }
    };
    const handleDraftButtonClick = (values) => {
        if (!values.question) {
            return;
        }
        handleAddResponse(values, true);
    };
    const handleCloseConfirmation = (type) => {
        if (type === 'Y') {
            dispatch({ type: setModalOpen, modalOpen: false });
            dispatch({ type: setIsConfirmationModalOpen, isConfirmationModalOpen: false });
            dispatch({ type: clearAddEditModalValue });
        } else {
            dispatch({ type: setIsConfirmationModalOpen, isConfirmationModalOpen: false });
        }
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        // dispatch({ type: setSelectedItem, selectedItem: item });
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDelete = () => {
        // dispatch({ type: setModalOpen, modalOpen: true });
        // dispatch({ type: setModalType, modalType: 'delete' });
        // dispatch({ type: setActionType, typeOfAction: 'I' });
        handleClose();
    };

    const openPopover = Boolean(anchorEl);
    const id = openPopover ? 'question-delete-popover' : undefined;
    return (
        <>
            <Stack sx={{ padding: '24px 24px 16px' }} direction="row" justifyContent="space-between">
                <Stack direction="row">
                    <Breadcrumbs className="question-registry-breadcrumbs" separator={<NavigateNextIcon />} aria-label="breadcrumb">
                        <Link href="/">
                            <AllQuestionsIcon />
                            All questions
                        </Link>
                        <Typography
                            sx={{ display: 'flex', alignItems: 'center' }}
                            color="#00214D"
                            fontWeight="600"
                            component="span"
                            fontSize="0.875rem"
                            lineHeight="1.1"
                        >
                            <QuestionRegistryIcon />
                            {title}
                        </Typography>
                    </Breadcrumbs>
                </Stack>

                <Stack direction="row" className="actions">
                    {/* <IconButton className={`${starred ? 'active' : ''} star-icon`} onClick={handleStarred} disableRipple>
                        {starred ? <StarFilledIcon /> : <StarIcon />}
                    </IconButton>
                    <IconButton className="three-dots" disableRipple onClick={handleClick}>
                        <MoreHoriz className="dot" />
                    </IconButton> */}
                    <IconButton
                        // onClick={() => {
                        //     if (hasInputValue && !hasInputNoChange) {
                        //         // dispatch({ type: setIsConfirmationModalOpen, isConfirmationModalOpen: true });
                        //         return;
                        //     }
                        //     handleCloseConfirmation('Y');
                        // }}

                        onClick={() => {
                            // setFieldValue('isDrafted', true);
                            if (!formState.question && !formState.response) {
                                dispatch({ type: setModalOpen, modalOpen: false });
                                return;
                            }
                            handleDraftButtonClick(formState);
                        }}
                        className="modal-close"
                        disableRipple
                    >
                        <CloseOutlinedIcon className="icon-yellow-fill" />
                    </IconButton>
                </Stack>
            </Stack>
            <Divider sx={{ backgroundColor: '#EDE7F6' }} />

            <Box className="modal-body">
                <Formik
                    initialValues={{
                        isDrafted: false,
                        question: '',
                        response: ''
                    }}
                    validationSchema={Yup.object().shape({
                        question: Yup.string().required('Please provide a question.'),
                        response: Yup.string().when('isDrafted', {
                            is: false,
                            then: Yup.string().required('Please provide a response.')
                        })
                    })}
                >
                    {({ errors, handleBlur, handleChange, touched, values, setFieldValue }) => (
                        <Form>
                            <Stack>
                                <PerfectScrollbar
                                    style={{ height: 'calc(100vh - 220px)', maxHeight: 'calc(100vh - 220px)', padding: '0 6px 0 0' }}
                                    options={{ suppressScrollX: true, useBothWheelAxes: false }}
                                >
                                    <Stack className="field-box" gap={1} sx={{ minHeight: '255px', maxHeight: 'calc(100vh - 72px)' }}>
                                        <FormControl
                                            error={Boolean(touched.title && errors.title)}
                                            sx={{ ...theme.typography.customInput }}
                                        >
                                            {/* <InputLabel htmlFor="outlined-adornment-title">Question</InputLabel> */}
                                            {/* <FormFields
                                                type="outlined-input"
                                                name="question"
                                                value={values.question}
                                                id="outlined-adornment-title"
                                                onBlur={handleBlur}
                                                placeholder="Untitled question"
                                                onChange={(e) => {
                                                    let flag = false;
                                                    if (values.response || e.target.value) flag = true;
                                                    dispatch({ type: setHasInputChange, hasInputValue: flag });
                                                    if (!e.target.value && !values.response)
                                                        dispatch({ type: setHasInputNoChange, hasInputNoChange: true });
                                                    else dispatch({ type: setHasInputNoChange, hasInputNoChange: false });
                                                    handleChange(e);
                                                }}
                                                inputprops={{}}
                                            /> */}
                                            <Input
                                                type="outlined-input"
                                                name="question"
                                                value={values.question}
                                                id="outlined-adornment-title"
                                                onBlur={handleBlur}
                                                placeholder="Untitled question"
                                                onChange={(e) => {
                                                    let flag = false;
                                                    if (values.response || e.target.value) flag = true;
                                                    dispatch({ type: setHasInputChange, hasInputValue: flag });
                                                    if (!e.target.value && !values.response)
                                                        dispatch({ type: setHasInputNoChange, hasInputNoChange: true });
                                                    else dispatch({ type: setHasInputNoChange, hasInputNoChange: false });
                                                    handleChange(e);
                                                    setTitle(e.target.value !== '' ? e.target.value : 'Untitled question');

                                                    setFormState({
                                                        ...formState,
                                                        question: e.target.value
                                                    });
                                                }}
                                                inputprops={{}}
                                            />
                                        </FormControl>
                                        <FormControl
                                            error={Boolean(touched.text && errors.text)}
                                            sx={{ ...theme.typography.customInput }}
                                            className="contact-textarea-formcontrol"
                                        >
                                            {/* <InputLabel htmlFor="outlined-adornment-text-response">Response</InputLabel>
                                            <FormFields
                                                id="outlined-adornment-responsetext-response"
                                                type="outlined-input"
                                                value={values.response}
                                                name="response"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    let flag = false;
                                                    if (values.question || e.target.value) flag = true;
                                                    dispatch({ type: setHasInputChange, hasInputValue: flag });
                                                    if (!values.question && !e.target?.value)
                                                        dispatch({ type: setHasInputNoChange, hasInputNoChange: true });
                                                    else dispatch({ type: setHasInputNoChange, hasInputNoChange: false });
                                                    handleChange(e);
                                                }}
                                                label="Response"
                                                multiline
                                                rows={4}
                                            /> */}

                                            <Input
                                                id="outlined-adornment-responsetext-response"
                                                type="outlined-input"
                                                value={values.response}
                                                name="response"
                                                placeholder="Type your response here"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    let flag = false;
                                                    if (values.question || e.target.value) flag = true;
                                                    dispatch({ type: setHasInputChange, hasInputValue: flag });
                                                    if (!values.question && !e.target?.value)
                                                        dispatch({ type: setHasInputNoChange, hasInputNoChange: true });
                                                    else dispatch({ type: setHasInputNoChange, hasInputNoChange: false });
                                                    handleChange(e);
                                                    setFormState({
                                                        ...formState,
                                                        response: e.target.value
                                                    });
                                                }}
                                                label="Response"
                                                multiline
                                                // rows={4}
                                            />
                                        </FormControl>
                                    </Stack>
                                </PerfectScrollbar>
                                <Stack
                                    justifyContent="flex-end"
                                    direction="row"
                                    sx={{
                                        padding: '16px'
                                    }}
                                    gap={1}
                                >
                                    <Button
                                        type="submit"
                                        disabled={hasInputNoChange || !values.question}
                                        className="alternate-reversed"
                                        onClick={() => {
                                            setFieldValue('isDrafted', true);
                                            handleDraftButtonClick(values);
                                        }}
                                    >
                                        Save as draft
                                    </Button>
                                    <Button
                                        type="submit"
                                        className="alternate white"
                                        disabled={hasInputNoChange || !values.question || !values.response}
                                        startIcon={<CheckRoundedIcon />}
                                        disableRipple
                                        onClick={() => {
                                            setFieldValue('isDrafted', false);

                                            if (!values.question || !values.response) {
                                                return;
                                            }

                                            handleAddResponse(values, false);
                                        }}
                                    >
                                        Save
                                    </Button>
                                </Stack>
                                {/* <Box>
                                    <Box className="modal-footer-2">
                                        <Button
                                            type="submit"
                                            disabled={hasInputNoChange}
                                            className="alternate-reversed"
                                            onClick={() => {
                                                setFieldValue('isDrafted', true);
                                                handleDraftButtonClick(values);
                                            }}
                                        >
                                            Save as draft
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="alternate"
                                            disabled={hasInputNoChange}
                                            onClick={() => {
                                                setFieldValue('isDrafted', false);

                                                if (!values.question || !values.response) {
                                                    return;
                                                }

                                                handleAddResponse(values, false);
                                            }}
                                        >
                                            Add
                                        </Button>
                                    </Box>
                                </Box> */}
                            </Stack>
                        </Form>
                    )}
                </Formik>
                {/* {isConfirmationModalOpen && <CloseConfirmationModal parentModalClose={handleCloseConfirmation} />} */}
            </Box>

            <Popover
                id={id}
                open={openPopover}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                className="question-delete-popover"
                sx={{
                    width: '200px'
                }}
            >
                <Box className="popover-wrap">
                    <List>
                        <MenuItem onClick={handleDelete} disableRipple>
                            <ListItemIcon>{<TrashIcon />}</ListItemIcon>
                            <ListItemText>Delete question</ListItemText>
                        </MenuItem>
                    </List>
                </Box>
            </Popover>
        </>
    );
};

export default AddNewTemplate;
